import ConfigCmsApi from '../configs/ConfigCmsApi';
import Cookies from "js-cookie";

const getClinics = (params) => ConfigCmsApi.get('/clinics/', {
  params,
  headers: {
    Authorization: Cookies.get('adminToken'),
  },
});

const getClinic = (clinicId, options = {}) => ConfigCmsApi.get(`/clinics/${clinicId}`, {
  timeout: options.timeout || 0,
  headers: {
    Authorization: Cookies.get('adminToken'),
  },
});

const updateClinic = ({ data, clinicId }) => ConfigCmsApi.post(`/clinics/${clinicId}`, data, {
  headers: {
    Authorization: Cookies.get('adminToken'),
  },
});

const getAccreditations = () => ConfigCmsApi.get('/clinics/accreditations', {
  headers: {
    Authorization: Cookies.get('adminToken'),
  },
});

const addImages = ({ clinicId, file }) => {
  const bodyFormData = new FormData();
  bodyFormData.append('file', file);

  return ConfigCmsApi.post(`/clinics/${clinicId}/add-images`, bodyFormData, {
    headers: {
      Authorization: Cookies.get('adminToken'),
    },
  });
};
const uploadLogo = ({ clinicId, file }) => {
  const bodyFormData = new FormData();
  bodyFormData.append('file', file);

  return ConfigCmsApi.post(`/clinics/${clinicId}/logo`, bodyFormData, {
    headers: {
      Authorization: Cookies.get('adminToken'),
    },
  });
};

const deleteLogo = ({ clinicId }) => ConfigCmsApi.delete(`/clinics/${clinicId}/logo`, {
  headers: {
    Authorization: Cookies.get('adminToken'),
  },
});

const getTopPlacements = ({ clinicId }) => ConfigCmsApi.get(`/clinics/${clinicId}/top-placements`, {
  headers: {
    Authorization: Cookies.get('adminToken'),
  },
});

const getTopPlacementRegistry = params => ConfigCmsApi.get('/clinics/top-placements/registry', {
  params, headers: { Authorization: Cookies.get('adminToken') },
});
const getTopPlacementReservations = params => ConfigCmsApi.get('/clinics/top-placements/reservations', {
  params, headers: { Authorization: Cookies.get('adminToken') },
});

const createTopPlacement = ({ clinicId, data }) => ConfigCmsApi.post(`/clinics/${clinicId}/top-placements`, data, {
  headers: {
    Authorization: Cookies.get('adminToken'),
  },
});

const topPlacementPath = placementId => {
  if (typeof placementId !== 'string' || !placementId.trim() || placementId === 'undefined') {
    throw new Error('Top placement is missing placement_id');
  }
  return `/clinics/top-placements/${encodeURIComponent(placementId)}`;
};

const rescheduleTopPlacement = ({ placementId, data }) => ConfigCmsApi.post(topPlacementPath(placementId), data, {
  headers: {
    Authorization: Cookies.get('adminToken'),
  },
});

const changeTopPlacement = ({ placementId, action }) => ConfigCmsApi.post(`${topPlacementPath(placementId)}/${action}`, {}, {
  headers: {
    Authorization: Cookies.get('adminToken'),
  },
});

const directionAdvertisingPath = ({ clinicId, illnessKindId }) => `/clinics/${clinicId}/advertising/illness-kinds/${illnessKindId}`;

/** Listing (balance-driven) advertising of one direction: create = create and start. */
const switchDirectionAdvertising = ({ clinicId, illnessKindId, action }) => ConfigCmsApi.post(
  action === 'create'
    ? directionAdvertisingPath({ clinicId, illnessKindId })
    : `${directionAdvertisingPath({ clinicId, illnessKindId })}/${action}`,
  {},
  {
    headers: {
      Authorization: Cookies.get('adminToken'),
    },
  },
);

const getBalanceAdvertising = ({ clinicId }) => ConfigCmsApi.get(`/clinics/${clinicId}/advertising`, {
  headers: {
    Authorization: Cookies.get('adminToken'),
  },
});

const getClinicEntityAliasesByLang = ({ clinicId, lang, entity, entityId }) => ConfigCmsApi.get(`/clinics/${clinicId}/entity-texts/${lang}/${entity}/${entityId}`, {
  headers: {
    Authorization: Cookies.get('adminToken'),
  },
});

const updateClinicEntityAliasesByLang = ({ clinicId, lang, entity, entityId, data }) => ConfigCmsApi.post(`/clinics/${clinicId}/entity-texts/${lang}/${entity}/${entityId}`, data, {
  headers: {
    Authorization: Cookies.get('adminToken'),
  },
});

const getClinicDomainTexts = ({ clinicId, lang }) => ConfigCmsApi.get(`/clinics/${clinicId}/domain-texts/${lang}`, {
  headers: {
    Authorization: Cookies.get('adminToken'),
  },
});

const updateClinicDomainTexts = ({ clinicId, lang, data }) => ConfigCmsApi.post(`/clinics/${clinicId}/domain-texts/${lang}`, data, {
  headers: {
    Authorization: Cookies.get('adminToken'),
  },
});
const sendEntities = (data) => {
  return ConfigCmsApi.post('/notification-center/content-work-done',data, {
    headers: {
      Authorization: Cookies.get('adminToken'),
    },
  });
};

export default {
  getClinics,
  getClinic,
  updateClinic,
  getAccreditations,
  addImages,
  uploadLogo,
  deleteLogo,
  getTopPlacements,
  getTopPlacementRegistry,
  getTopPlacementReservations,
  createTopPlacement,
  rescheduleTopPlacement,
  changeTopPlacement,
  getBalanceAdvertising,
  switchDirectionAdvertising,
  getClinicEntityAliasesByLang,
  updateClinicEntityAliasesByLang,
  getClinicDomainTexts,
  updateClinicDomainTexts,
  sendEntities,
};
